<template>
  <div class="cmd00800-container">
    <PageHeaderBanner>
      <template #title>商品情報一覧</template>
    </PageHeaderBanner>
    <q-expansion-item v-model="open" header-style="display:none">
      <div class="cmd00800-conditions-form">
        <q-card style="background: var(--q-lightGray)" flat bordered>
          <q-card-section class="q-gutter-y-lg">
            <div class="row q-gutter-x-sm">
              <div class="col" style="max-width: 450px">
                <label>構造式</label>
                <iframe
                  id="sketch-iframe"
                  ref="sketch-iframe"
                  data-toolbars="reporting"
                  title="marvin js editor"
                  src="../../sketch/editorws.html"
                  style="overflow: hidden; width:100%; height: 100% min-width: 500px; min-height: 350px; border: 1px solid darkgray"
                ></iframe>
              </div>
              <div class="col q-gutter-y-sm">
                <div class="row q-gutter-x-sm">
                  <div class="col">
                    <label>ATTO_ID</label>
                    <q-input
                      v-model.trim="searchCondtions.atto_id"
                      outlined
                      dense
                      maxlength="12"
                      style="background: var(--q-white)"
                      class="input-area"
                    />
                  </div>
                  <div class="col">
                    <label>サプライヤ商品コード</label>
                    <q-input
                      v-model.trim="searchCondtions.id_number"
                      outlined
                      dense
                      maxlength="200"
                      style="background: var(--q-white)"
                      class="input-area"
                    />
                  </div>
                </div>
                <div class="row q-gutter-x-sm">
                  <div class="col">
                    <label>CAS No.</label>
                    <q-input
                      v-model.trim="searchCondtions.cas"
                      outlined
                      dense
                      maxlength="30"
                      style="background: var(--q-white)"
                      class="input-area"
                    />
                  </div>
                  <div class="col">
                    <label>MDL</label>
                    <q-input
                      v-model.trim="searchCondtions.mdl"
                      outlined
                      dense
                      maxlength="30"
                      style="background: var(--q-white)"
                      class="input-area"
                    />
                  </div>
                </div>
                <div class="row q-gutter-x-sm">
                  <div class="col">
                    <label>化学名１</label>
                    <q-input
                      v-model.trim="searchCondtions.name1"
                      outlined
                      dense
                      maxlength="2000"
                      style="background: var(--q-white)"
                      class="input-area"
                    />
                  </div>
                </div>
                <div class="row q-gutter-x-sm">
                  <div class="col">
                    <label>化学名２</label>
                    <q-input
                      v-model.trim="searchCondtions.name2"
                      outlined
                      dense
                      maxlength="2000"
                      style="background: var(--q-white)"
                      class="input-area"
                    />
                  </div>
                </div>
                <div class="row q-gutter-x-sm">
                  <div class="col">
                    <label>Purity</label>
                    <q-input
                      v-model.trim="searchCondtions.purity"
                      outlined
                      dense
                      maxlength="100"
                      style="background: var(--q-white)"
                      class="input-area"
                    />
                  </div>
                  <div class="col">
                    <label>Storage</label>
                    <q-input
                      v-model.trim="searchCondtions.storage"
                      outlined
                      dense
                      maxlength="200"
                      style="background: var(--q-white)"
                      class="input-area"
                    />
                  </div>
                </div>
                <div class="row q-gutter-x-sm">
                  <div class="col">
                    <label>Hazard Information</label>
                    <q-input
                      v-model.trim="searchCondtions.hazardInfo"
                      outlined
                      dense
                      maxlength="200"
                      style="background: var(--q-white)"
                      class="input-area"
                    />
                  </div>
                  <div class="col">
                    <label>Solubility</label>
                    <q-input
                      v-model.trim="searchCondtions.solubility"
                      outlined
                      dense
                      maxlength="200"
                      style="background: var(--q-white)"
                      class="input-area"
                    />
                  </div>
                </div>
                <div class="row q-gutter-x-sm">
                  <div class="col-6">
                    <label>Target</label>
                    <q-input
                      v-model.trim="searchCondtions.target"
                      outlined
                      dense
                      maxlength="200"
                      style="background: var(--q-white)"
                      class="input-area"
                    />
                  </div>
                </div>
                <div class="row q-gutter-x-sm">
                  <div class="col">
                    <label>備考</label>
                    <q-input
                      v-model.trim="searchCondtions.memo"
                      outlined
                      dense
                      maxlength="200"
                      style="background: var(--q-white)"
                      class="input-area"
                    />
                  </div>
                </div>
                <div class="row q-gutter-x-sm">
                  <div class="col">
                    <label>Supplier_URL</label>
                    <q-input
                      v-model.trim="searchCondtions.url"
                      outlined
                      dense
                      maxlength="300"
                      style="background: var(--q-white)"
                      class="input-area"
                    />
                  </div>
                </div>

                <div class="row q-gutter-x-sm">
                  <div class="col">
                    <label>CoA</label>
                    <q-input
                      v-model.trim="searchCondtions.coa"
                      outlined
                      dense
                      maxlength="300"
                      style="background: var(--q-white)"
                      class="input-area"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="q-gutter-x-xs flex justify-end">
              <q-btn
                color="primary"
                style="width: 150px"
                label="検索"
                icon="mdi-magnify"
                @click="searchGoods"
              />
              <q-btn
                outline
                style="width: 150px; background: var(--q-white) !important; color: var(--q-delete)"
                icon="mdi-eraser"
                label="クリア"
                @click="clearSearchCondition"
              />
            </div>
          </q-card-section>
        </q-card>
      </div>
    </q-expansion-item>

    <SearchOpenCloseButton
      :display="searchResult"
      :open="open"
      style="margin-bottom: 20px"
      @open="open = $event"
    />
    <div ref="searchResultElement" class="cmd00800-result-table">
      <div
        :class="
          'chem-table-area btn-exist table-top-button ' + (data.length === 0 ? 'table-nodata' : '')
        "
      >
        <q-table
          class="my-sticky-header-column-table"
          :rows="data"
          :columns="columns"
          row-key="index"
          flat
          dense
          :visible-columns="visibleColumns"
          separator="cell"
          :no-data-label="tableMessage"
          :rows-per-page-options="[10, 20, 50]"
          rows-per-page-label="件表示"
          rows-per-page="20"
          :pagination-label="
            (firstRowIndex, endRowIndex, totalRowsNumber) => {
              return `${totalRowsNumber} 件中 ${firstRowIndex}～${endRowIndex} 件表示`;
            }
          "
        >
          <template #no-data="{ message }">
            <div class="full-width row q-gutter-sm">
              <q-icon size="24px" name="mdi-alert-circle-outline" />
              <span class="q-pt-xs">{{ message }}</span>
            </div>
          </template>
          <template #top>
            <div class="add-btn-area flex items-center filter-select">
              <q-select
                v-model="visibleColumns"
                multiple
                outlined
                dense
                options-dense
                display-value="カラム表示設定"
                emit-value
                map-options
                :options="visibleColumnOptions"
                option-value="name"
                color="primary"
                class="column-disp"
              />
            </div>
          </template>
          <!-- 編集削除Header -->
          <template #header-cell-editDelete>
            <q-th class="table-btn-area delete-btn-exists"></q-th>
          </template>
          <!-- 編集、削除Body -->
          <template #body-cell-editDelete="cell">
            <q-td class="table-btn-area delete-btn-exists">
              <div class="flex">
                <q-btn
                  icon="mdi-pencil"
                  label="編集"
                  color="primary"
                  @click="editData(cell.row.mol_id)"
                />
                <q-btn
                  icon="mdi-close"
                  label="削除"
                  class="deletebtn"
                  color="primary"
                  outline
                  style="color: var(--q-delete)"
                  @click="displayDeleteGoodsDialog(cell.row.mol_id, cell.row.id_number)"
                />
              </div>
            </q-td>
          </template>
          <template #body-cell-structure="structure">
            <q-td>
              <div style="width: 180px; min-width: 180px; max-width: 180px; padding: 2px">
                <AtomImage :exatoms="structure.row.structure" />
              </div>
            </q-td>
          </template>
          <template #body-cell-url="body">
            <q-td :props="body" :class="body.row.del_flg === '1' ? 'deleted' : ''">
              <a :href="body.value" target="_blank">{{ body.value }}</a>
            </q-td>
          </template>
        </q-table>
      </div>
    </div>
    <!--削除表示ダイアログ-->
    <AlertDialog
      :display="isDeleteDisplayFlg"
      :level="dialogLevel"
      :confirmation="dialogConFlg"
      :title="dialogTitle"
      :text="dialogText"
      @confirm="deleteGoods"
      @complete="isDeleteDisplayFlg = false"
      @close="isDeleteDisplayFlg = false"
    />
    <!--検索総件数が500件超えた場合のダイアログ-->
    <AlertDialog
      :display="resultOverFlg"
      level="warning"
      confirmation
      :title="dialogTitle"
      :text="dialogText"
      @complete="closeDialog"
    />
    <!--検索条件未入力の場合のダイアログ-->
    <AlertDialog
      :display="isSearchDisplayFlg"
      level="error"
      confirmation
      :title="dialogTitle"
      :text="dialogText"
      @complete="isSearchDisplayFlg = false"
    />
    <!--削除エラーが発生する場合のダイアログ-->
    <AlertDialog
      :display="isDeleteErrFlg"
      level="error"
      confirmation
      :title="dialogTitle"
      :text="dialogText"
      @complete="isDeleteErrFlg = false"
      @close="isDeleteErrFlg = false"
    />
  </div>
</template>
<script setup lang="ts">
import { Loading } from 'quasar';
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import axios from '../../common/axios-common';
import DetailResultStatusCode from '../../common/code/DetailResultStatusCode';
import HttpResponseStatusCode from '../../common/code/HttpResponseStatusCode';
import ResultStatusCode from '../../common/code/ResultStatusCode';
import { getMarvin, clearMarvin } from '../../common/marvin-js';
import AtomImage from '../../components/images/AtomImage.vue';
import PageHeaderBanner from '../../components/banner/PageHeaderBanner.vue';
import SearchOpenCloseButton from '../../components/button/SearchOpenCloseButton.vue';
import AlertDialog from '../../components/dialogs/AlertDialog.vue';
import messages from '../../messages/message.json';

interface Nmol {
  mol_id: string;
  atto_id: string;
  structure: string;
  id_number: string;
  cas_number: string;
  mdl: string;
  name1: string;
  name2: string;
  storage: string;
  hazard_info: string;
  solubility: string;
  target: string;
  memo: string;
  url: string;
  coa: string;
  purity: string;
}
// カラム表示機能
interface VisibleColumn {
  name: string;
  label: string;
}
// 商品ID
const delMolId = ref('');
// カラムプルダウン開閉
const open = ref(true);
// 検索結果上限超過フラグ
const resultOverFlg = ref<boolean>(false);
// 検索結果要素
const searchResultElement = ref<HTMLImageElement>();
// 検索可能フラグ
const isContentsExist = ref<boolean>(false);
// 検索エラーダイアログ表示フラグ
const isSearchDisplayFlg = ref<boolean>(false);
// 検索結果フラグ
const searchResult = ref(false);
// ダイアログのconfirmation(trueならキャンセルボタンを表示しない)
const dialogConFlg = ref(false);
// Dialogタイトル
const dialogTitle = ref('');
// Dialog本文
const dialogText = ref(['']);
// Dialog表示レベル
const dialogLevel = ref('');
// 削除確認Dialog表示フラグ
const isDeleteDisplayFlg = ref(false);
// エラーDialog表示フラグ
const isDeleteErrFlg = ref(false);
// テーブルメッセージ
const tableMessage = ref('検索してください。');
// 遷移先のrouter
const router = useRouter();
// 入力データ
const data = ref<Nmol[]>([]);
// 表示カラム
const visibleColumns = ref<Array<string>>([]);
// カラム表示設定の選択肢
const visibleColumnOptions = ref<Array<VisibleColumn>>([]);
// 検索に必要なデータ
const searchCondtions = ref({
  mol_id: '',
  atto_id: '',
  structure: '',
  id_number: '',
  name1: '',
  name2: '',
  purity: '',
  storage: '',
  hazardInfo: '',
  solubility: '',
  target: '',
  memo: '',
  url: '',
  coa: '',
  cas: '',
  mdl: '',
});

// 検索条件（保持用）
const saveSearchCondition = ref({ ...searchCondtions.value });

// カラム
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const columns: Array<any> = [
  {
    name: 'editDelete',
    field: (row: Nmol) => row.mol_id,
    required: true,
  },
  {
    name: ' atto_id',
    label: 'ATTO_ID',
    align: 'left',
    field: (row: Nmol) => row.atto_id,
    sortable: true,
  },
  {
    name: 'structure',
    label: '構造',
    align: 'left',
    field: (row: Nmol) => row.structure,
    classes: 'cmd00800-structure',
    headerClasses: 'cmd00800-structure',
  },
  {
    name: 'id_number',
    label: 'サプライヤ商品コード',
    align: 'left',
    field: (row: Nmol) => row.id_number,
    sortable: true,
  },
  {
    name: 'cas_number',
    label: 'CAS No.',
    align: 'left',
    field: (row: Nmol) => row.cas_number,
    sortable: true,
  },
  {
    name: 'mdl',
    label: 'MDL',
    align: 'left',
    field: (row: Nmol) => row.mdl,
    sortable: true,
  },
  {
    name: 'name1',
    label: '化学名１',
    align: 'left',
    field: (row: Nmol) => row.name1,
    sortable: true,
  },
  {
    name: 'name2',
    label: '化学名２',
    align: 'left',
    field: (row: Nmol) => row.name2,
    sortable: true,
  },
  {
    name: 'purity',
    label: 'Purity',
    align: 'left',
    field: (row: Nmol) => row.purity,
    sortable: true,
  },
  {
    name: 'storage',
    label: 'Storage',
    align: 'left',
    field: (row: Nmol) => row.storage,
    sortable: true,
  },
  {
    name: 'hazard_info',
    label: 'Hazard Information',
    align: 'left',
    field: (row: Nmol) => row.hazard_info,
    sortable: true,
  },
  {
    name: 'solubility',
    label: 'Solubility',
    align: 'left',
    field: (row: Nmol) => row.solubility,
    sortable: true,
  },
  {
    name: 'target',
    label: 'Target',
    align: 'left',
    field: (row: Nmol) => row.target,
    sortable: true,
  },
  {
    name: 'memo',
    label: '備考',
    align: 'left',
    field: (row: Nmol) => row.memo,
    sortable: true,
  },
  {
    name: 'url',
    label: 'Supplier_URL',
    align: 'left',
    field: (row: Nmol) => row.url,
    sortable: true,
  },
  {
    name: 'coa',
    label: 'CoA',
    align: 'left',
    field: (row: Nmol) => row.coa,
    sortable: true,
  },
];

/**
 * 商品削除確認ダイアログ表示
 * @param {string} molId 商品ID
 * @param {string} idNumber サプライヤ商品コード
 */
const displayDeleteGoodsDialog = (molId: string, idNumber: string) => {
  delMolId.value = molId;
  dialogLevel.value = 'warning';
  // 削除確認ダイアログのtitleを設定
  dialogTitle.value = '削除確認';
  // 削除確認ダイアログのtextを生成
  dialogText.value = [`サプライヤ商品コード：${idNumber} を削除します。`, `よろしいですか？`];
  // ダイアログ表示判断をtrue(表示)に変更
  isDeleteDisplayFlg.value = true;
  // ダイアログのボタン数判断をfalse(2つ)に
  dialogConFlg.value = false;
};

/**
 * 検索件数上限超過チェック
 * @param {string} searchNumTotal 検索結果件数
 */
const checkOverResult = (searchNumTotal: number) => {
  if (searchNumTotal > Number(messages.ja.validation.search_max_count)) {
    dialogText.value = [
      `先頭から${messages.ja.validation.search_max_count}件までの検索結果を表示しています。`,
      'お探しの化合物が見つからない場合、検索条件を絞り込んで再度検索してください。',
    ];
    dialogTitle.value = '検索結果上限値超過';
    resultOverFlg.value = true;
  }
};

/**
 * 商品検索
 */
const searchGoods = () => {
  isContentsExist.value = false;
  getMarvin().then((structure: string) => {
    // MarvinJs読み込み失敗
    if (structure === 'error') {
      dialogTitle.value = 'MarvinJs読み込みエラー';
      dialogText.value = ['構造式の取得に失敗しました。', '画面を開き直して再度お試しください。'];
      isContentsExist.value = false;
    }

    // 検索条件が1つ以上入力されていることをチェック
    Object.entries(searchCondtions.value).forEach(([, value]) => {
      if (value) {
        isContentsExist.value = true;
        isSearchDisplayFlg.value = false;
      }
    });

    // 検索値が入力された場合、検索開始
    if (!isContentsExist.value && structure === undefined) {
      dialogTitle.value = '検索条件入力エラー';
      dialogText.value = ['検索条件を1つ以上入力し、検索してください。'];
      isSearchDisplayFlg.value = true;
    } else {
      // Loading Start
      Loading.show();
      // バックエンド側にデータを連携
      const formData = new FormData();
      formData.append('atto_id', searchCondtions.value.atto_id);
      formData.append('id_number', searchCondtions.value.id_number);
      formData.append('mdl', searchCondtions.value.mdl);
      formData.append('name1', searchCondtions.value.name1);
      formData.append('name2', searchCondtions.value.name2);
      formData.append('purity', searchCondtions.value.purity);
      formData.append('storage', searchCondtions.value.storage);
      formData.append('hazard_info', searchCondtions.value.hazardInfo);
      formData.append('solubility', searchCondtions.value.solubility);
      formData.append('target', searchCondtions.value.target);
      formData.append('structure', structure !== undefined ? structure : '');
      formData.append('memo', searchCondtions.value.memo);
      formData.append('url', searchCondtions.value.url);
      formData.append('cas_number', searchCondtions.value.cas);
      formData.append('coa', searchCondtions.value.coa);
      // 検索実行
      axios
        .post('/cmd008001/search', formData)
        .then((res) => {
          const { common, goodsList, searchNumTotal } = res.data;
          switch (common.status) {
            // 正常終了の場合
            case ResultStatusCode.SUCCESS:
              saveSearchCondition.value = { ...searchCondtions.value };
              checkOverResult(searchNumTotal);
              data.value = goodsList;
              searchResult.value = true;
              tableMessage.value = 'データがありません。';
              break;
            // エラーの場合
            case ResultStatusCode.ERROR:
              switch (common.detail_status) {
                // システムエラーの場合
                case DetailResultStatusCode.STATEMENT_TIMEOUT:
                  dialogTitle.value = '検索時間超過エラー';
                  dialogText.value = [
                    `検索時間が上限に達しました。条件を見直して再検索してください。`,
                  ];
                  isSearchDisplayFlg.value = true;
                  break;
                case DetailResultStatusCode.PARAMETER_ERROR:
                case DetailResultStatusCode.SYSTEM_ERROR:
                  router.push({ name: 'error' });
                  break;
                default:
              }
              break;
            default:
              router.push({ name: 'error' });
          }
        })
        .catch((err) => {
          if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
            // セッションタイムアウトの場合
            router.push({ name: 'login', query: { timeout: 'timeout' } });
          } else {
            // その他エラーの場合
            router.push({ name: 'error' });
          }
        })
        .finally(() => {
          // Loading End
          Loading.hide();
          // スクロール
          setTimeout(() => searchResultElement.value?.scrollIntoView(true), 800);
        });
    }
  });
};

/**
 * 検索条件クリア
 */
const clearSearchCondition = () => {
  clearMarvin().then((err: string) => {
    // MarvinJs読み込み失敗
    if (err === 'error') {
      dialogTitle.value = 'MarvinJs読み込みエラー';
      dialogText.value = ['構造式のクリアに失敗しました。', '画面を開き直して再度お試しください。'];
      isContentsExist.value = false;
    }
  });
  searchCondtions.value.atto_id = '';
  searchCondtions.value.id_number = '';
  searchCondtions.value.mdl = '';
  searchCondtions.value.name1 = '';
  searchCondtions.value.name2 = '';
  searchCondtions.value.purity = '';
  searchCondtions.value.storage = '';
  searchCondtions.value.hazardInfo = '';
  searchCondtions.value.solubility = '';
  searchCondtions.value.target = '';
  searchCondtions.value.memo = '';
  searchCondtions.value.url = '';
  searchCondtions.value.coa = '';
  searchCondtions.value.cas = '';
  searchCondtions.value.mdl = '';
};

/**
 * 商品情報変更画面に遷移
 * @param {string} molId 商品ID
 */
const editData = (molId: string) => {
  router.push({ name: 'catalogEdit', params: { molId } });
};

/**
 * ダイアログを閉じる
 */
const closeDialog = () => {
  resultOverFlg.value = false;
  setTimeout(() => searchResultElement.value?.scrollIntoView(true), 600);
};

/**
 * 商品削除
 */
const deleteGoods = async () => {
  // Loading Start
  isDeleteErrFlg.value = false;
  Loading.show();
  // 検索用データ作成
  const formData = new FormData();
  formData.append('atto_id', saveSearchCondition.value.atto_id);
  formData.append('mol_id', delMolId.value);
  formData.append('id_number', saveSearchCondition.value.id_number);
  formData.append('mdl', saveSearchCondition.value.mdl);
  formData.append('name1', saveSearchCondition.value.name1);
  formData.append('name2', saveSearchCondition.value.name2);
  formData.append('purity', saveSearchCondition.value.purity);
  formData.append('storage', saveSearchCondition.value.storage);
  formData.append('hazard_info', saveSearchCondition.value.hazardInfo);
  formData.append('solubility', saveSearchCondition.value.solubility);
  formData.append('target', saveSearchCondition.value.target);
  formData.append('memo', saveSearchCondition.value.memo);
  formData.append('url', saveSearchCondition.value.url);
  formData.append('cas_number', saveSearchCondition.value.cas);
  formData.append('coa', saveSearchCondition.value.coa);
  await axios
    .post('/cmd008001/delete', formData)
    .then((res) => {
      const { common, goodsList, searchNumTotal } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          dialogLevel.value = 'information';
          // 削除確認ダイアログのtitleを設定
          dialogTitle.value = '削除完了';
          // 削除確認ダイアログのtextを生成
          dialogText.value = [common.message];
          // ダイアログのボタン数判断をtrue(1つ)に
          dialogConFlg.value = true;
          checkOverResult(searchNumTotal);
          data.value = goodsList;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          isDeleteErrFlg.value = true;
          // 削除ダイアログのタイトル
          dialogTitle.value = 'エラー';
          // 削除ダイアログのtext生成
          dialogText.value = [common.message];
          break;
        // システムエラーの場合
        case DetailResultStatusCode.PARAMETER_ERROR:
        case DetailResultStatusCode.SYSTEM_ERROR:
          router.push({ name: 'error' });
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

// カラム表示設定
for (let i = 0; i < columns.length; i += 1) {
  visibleColumns.value.push(columns[i].name);
  // 編集削除ボタンのカラムは除外
  if (columns[i].name !== 'editDelete') {
    visibleColumnOptions.value.push({
      name: columns[i].name,
      label: columns[i].label,
    });
  }
}
</script>
<style scoped>
.cmd00800-conditions-form {
  width: 80%;
  margin: 0 auto 20px;
}
.cmd00800-result-table {
  width: 90%;
  margin: -60px auto 0;
  padding-top: 60px;
}
</style>
<style>
.cmd00800-structure {
  min-width: 180px;
  max-width: 180px;
  width: 180px;
}
</style>
